import React, { Component, Context } from "react";
import { RouteComponentProps } from "react-router";
import { connectCustom, ICustomStoreConnectedProps } from "../../redux/actions";
import { ISiteGalleryContent } from "../../models/cms";
import { IImage, getSiteMedia } from "../../models/Image";
import LayoutContext, { ILayoutContext } from "../../contexts/layout/LayoutContext";
import { getGalleryImageDimensions } from "../../models/layout";
import ImageEnlarge from "../ui/Media/ImageEnlarge";
import { renderGridOrphans, scrollToTop } from "../../utils";
import { getDateDisplay } from "../../utils/date-utils";
import { UIPageTitle } from "../ui/UIPageTitle";
import "./Gallery.scss";

//   <ImageThumbnails images={this.props.images} className={(!this.props.galleryView ? "preview" : "") + " mt-4 my-2 animated fadeIn"} />

class GalleryPage extends Component<ICustomStoreConnectedProps & RouteComponentProps, any> {
	private routeKey: string;
	private _historySub = null;
	static contextType: Context<ILayoutContext> = LayoutContext;

	state = {
		galleryId: undefined,
	};

	get gallery(): ISiteGalleryContent {
		return (this.props.galleryStore.galleries || []).find(
			(c: ISiteGalleryContent) => c.id === this.state.galleryId
		);
	}

	componentDidMount() {
		this.props.galleryStoreDispatch.loadGalleries().then(() => {
			this.init();
		});
		this._historySub = this.props.history.listen((location, action) => {
			this.init(true);
		});
	}

	componentWillUnmount() {
		this._historySub();
	}

	init(fromRouter?: boolean) {
		const newRouteKey: string = this.props.location.key;
		if (fromRouter && newRouteKey === this.routeKey) return;
		this.routeKey = newRouteKey;
		const galleryId: any = this.props.match.params ? this.props.match.params["id"] : undefined;
		if (galleryId === this.state.galleryId) return;
		console.log("galleryId:", galleryId);
		this.setState({ galleryId });
		scrollToTop();
		const gallery = (this.props.galleryStore.galleries || []).find((c: ISiteGalleryContent) => c.id === galleryId);
		if (gallery)
			this.props.appStoreDispatch.setCurrentPage(
				{
					id: "gallery-page",
					active: true,
					created_at: null,
					updated_at: null,
					title: gallery.title,
					metaTitle: gallery.title,
					headline: gallery.headline,
					parentPage: "root",
					order: 0,
				},
				true,
				true,
				gallery.id
			);
	}

	render() {
		const gallery: ISiteGalleryContent = this.gallery;
		if (!gallery) return null;
		console.log("gallery loaded:", gallery);
		const imageDimensions = getGalleryImageDimensions(this.context.settings);
		const siteImages: IImage[] = (gallery.media || []).map((m: IImage) =>
			getSiteMedia(m, "galleries", gallery.folder)
		);
		const rowCount: number = Math.ceil(siteImages.length / imageDimensions.imagesPerRow);
		const orphansToAdd: number = (siteImages.length * rowCount) % imageDimensions.imagesPerRow;

		return (
			<LayoutContext.Provider value={{ ...this.context, ...imageDimensions }}>
				<UIPageTitle pageTitle={this.props.appStore.activePage.title || gallery.title} />
				<div className="w-100 bg-black position-relative">
					<div className="container section-padding white-side-right1 position-relative gallery-section-container">
						<div className="d-flex flex-column flex-md-row flex-wrap align-items-center align-items-md-start justify-content-center justify-content-md-around justify-content-xl-between">
							{siteImages.map((media: IImage, i: number) => {
								return (
									<div key={i} style={{ maxWidth: imageDimensions.imageWidth }} className="mb-5">
										<ImageEnlarge
											image={media}
											width={imageDimensions.imageWidth}
											height={imageDimensions.imageHeight}
											displayThumb={true}
											galleryImages={siteImages}
											selectedMediaIndex={i}
											scaleInEffect
										/>
										<div className="text-gray text-uppercase text-sm mt-4 mb-1">
											{getDateDisplay(media.mediaDate, null)}
										</div>
										<h3 className="subheading text-white">{media.title}</h3>
									</div>
								);
							})}
							{renderGridOrphans(orphansToAdd, <div style={{ width: imageDimensions.imageWidth }} />)}
						</div>
					</div>
				</div>
			</LayoutContext.Provider>
		);
	}
}

export default connectCustom(GalleryPage, ["appStore", "galleryStore"], true);

// export default connect<IGalleryState, IGalleryActionDispatches, any>(
// 	mapGalleryStateToProps,
// 	mapGalleryDispatchToProps
// )(withRouter(GalleryPage));
